(() => {
  let pending = null;
  let allowForm = null;
  let dialog;
  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'size-confirm-dialog';
    dialog.setAttribute('aria-labelledby', 'size-confirm-title');
    dialog.innerHTML = '<div class="size-confirm-content"><h2 id="size-confirm-title">Er dette riktig størrelse?</h2><p>Du har valgt størrelse <strong data-size-value></strong>. Sjekk at størrelsen stemmer før du legger varen i handlekurven.</p><button type="button" class="btn btn--primary btn--full" data-size-confirm>Ja, legg i handlekurven</button><button type="button" class="btn btn--text-link size-confirm-cancel" data-size-cancel>Nei, endre størrelse</button></div>';
    document.body.appendChild(dialog);
    dialog.querySelector('[data-size-confirm]').addEventListener('click', () => {
      const current = pending; pending = null; dialog.close();
      if (!current || !current.form.isConnected || current.select.value !== current.value) return;
      allowForm = current.form;
      try { current.form.requestSubmit(current.submitter && current.submitter.isConnected ? current.submitter : undefined); }
      finally { allowForm = null; }
    });
    dialog.querySelector('[data-size-cancel]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { if (pending) { const select = pending.select; pending = null; const button = select.closest('[data-option-buttons]')?.querySelector('[data-button]'); (button || select).focus(); } });
    return dialog;
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[data-product-form]') || allowForm === form) return;
    const root = form.closest('[data-section-type="product"], [data-section-type="featured-product"], [data-is-quick-view]');
    const select = root && root.querySelector('select[data-size-default]');
    if (!select || !select.value || select.value !== select.dataset.sizeDefault) return;
    event.preventDefault(); event.stopImmediatePropagation();
    pending = { form, select, value: select.value, submitter: event.submitter };
    const modal = getDialog(); modal.querySelector('[data-size-value]').textContent = select.value;
    if (!modal.open) modal.showModal();
  }, true);
})();
